import {useTranslation} from 'react-i18next';

import {InputFormik, SelectFormik} from 'components';
import {Option} from 'interfaces';
import {TRANSLATION_KEYS} from 'locale';

import {MessageType} from '../types';

const T_KEYS_MESSAGES = TRANSLATION_KEYS.USER.CONTENT.CLIENT_SESSION.LIVE_HELP.MESSAGES;

type Props = {
    item: any;
    path: string;
    last: boolean;
    interactiveChatOptions: Option[];
    messageTypeOptions: Option<MessageType>[];
}

const FIELDS = {
    TEXT: 'text',
    CHAT_ID: 'data.chatId',
    TYPE: 'type'
};

export const LiveHelpMessageInput: React.FC<Props> = ({item, path, last, interactiveChatOptions, messageTypeOptions}) => {
    const {t} = useTranslation();

    return (
        <div className='tw-flex -md:tw-flex-col tw-flex-grow tw-w-full tw-max-w-xl'>
            <SelectFormik
                className='md:tw-w-48 md:tw-mr-4'
                options={messageTypeOptions}
                valueAs='id'
                placeholder={t(T_KEYS_MESSAGES.TYPE)}
                name={`${path}${FIELDS.TYPE}`}
            />
            {item?.type === MessageType.Text &&
                <InputFormik
                    className='md:tw-w-96 -md:tw-mt-2'
                    required={!last}
                    validate={!last}
                    name={`${path}${FIELDS.TEXT}`}
                />}
            {item?.type === MessageType.InteractiveChat &&
                <SelectFormik
                    className='md:tw-w-96 -md:tw-mt-2'
                    options={interactiveChatOptions}
                    valueAs='id'
                    name={`${path}${FIELDS.CHAT_ID}`}
                />}
        </div>
    );
};